import type { ColumnType, ConfigType } from "../types";
import type { RankingType } from "lib/fetchers/rankings";

const companyRankingMandatory = [
  "rank",
  "location",
  "logoUrl",
  "companyAndUrl",
  "founded",
  "stage",
  "city",
  "country",
];

const investorRankingMandatory = [
  "rank",
  "city",
  "country",
  "dealCount",
  "focus",
  "fundLaunchYear",
  "fundType",
  "investorLogo",
  "investorNameAndUrl",
];

const companyColumns = [
  {
    displayName: "Rank",
    dataName: "rank",
    type: "number",
    sortable: true,
  },
  {
    displayName: "",
    dataName: "logoUrl",
    type: "fixedSizeImage",
    sortable: false,
    cellConfig: {
      wrapperClasses: "min-h-[80px] w-[80px]",
      imageHeight: 60,
      imageWidth: 60,
    },
  },
  {
    displayName: "Company",
    dataName: "companyAndUrl",
    type: "link",
    sortable: true,
  },
  {
    displayName: "Location",
    dataName: "location",
    type: "location",
    sortable: true,
  },
  {
    displayName: "Founded",
    dataName: "founded",
    type: "number",
    sortable: true,
  },
  {
    displayName: "Stage",
    dataName: "stage",
    type: "string",
    sortable: true,
  },
  {
    displayName: "Last Round Size",
    dataName: "lastRoundSize",
    type: "money",
    sortable: true,
  },
  {
    displayName: "Total Funding",
    dataName: "totalFunding",
    type: "money",
    sortable: true,
  },
];

const investorColumns = [
  {
    displayName: "Rank",
    dataName: "rank",
    type: "number",
    sortable: true,
  },
  {
    displayName: "",
    dataName: "investorLogo",
    type: "fixedSizeImage",
    sortable: false,
    cellConfig: {
      wrapperClasses: "min-h-[80px] w-[80px]",
      imageHeight: 60,
      imageWidth: 60,
    },
  },
  {
    displayName: "Investor",
    dataName: "investorNameAndUrl",
    type: "link",
    sortable: true,
  },
  {
    displayName: "Deal Count",
    dataName: "dealCount",
    type: "number",
    sortable: true,
  },
  {
    displayName: "Focus",
    dataName: "focus",
    type: "string",
    sortable: true,
  },
  {
    displayName: "Fund Launch Year",
    dataName: "fundLaunchYear",
    type: "number",
    sortable: true,
  },
  {
    displayName: "Fund Type",
    dataName: "fundType",
    type: "string",
    sortable: true,
  },
  {
    displayName: "Investor Url",
    dataName: "investorUrl",
    type: "link",
    sortable: false,
  },
  {
    displayName: "Latest Fund Size",
    dataName: "latestFundSize",
    type: "money",
    sortable: true,
  },
  {
    displayName: "Unicorn Count",
    dataName: "unicornCount",
    type: "number",
    sortable: true,
  },
];

export const rankingConfig: ConfigType = {
  trackingName: "Ranking",
  initialSort: "",
  isAscending: false,
  numberFilterOptions: 5,
  cellYPadding: 24,
  mandatoryColumns: [],
  columns: [],
};

export function getRankingConfig(
  rankingType: RankingType = "company"
): ConfigType {
  if (rankingType === "investor") {
    rankingConfig.mandatoryColumns = investorRankingMandatory;
    rankingConfig.columns = investorColumns as ColumnType[];
  } else {
    rankingConfig.mandatoryColumns = companyRankingMandatory;
    rankingConfig.columns = companyColumns as ColumnType[];
  }
  return rankingConfig;
}
